import { subCompaniesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE = createNamedActions(
  'subCompanyCompanyProfile',
  {
    GET_COMPANY_PROFILE: 'GET_COMPANY_PROFILE',
    UPDATE_COMPANY_PROFILE_SECTION: 'UPDATE_COMPANY_PROFILE_SECTION',
    RESET_COMPANY_PROFILE: 'RESET_COMPANY_PROFILE',
  },
);

// DEV-3611: the company-level view projected from the SubCompany (the single
// source). The editor's company-level sections read this instead of the cert
// profile so Overview and Setup never disagree.
export const getSubCompanyCompanyProfileAction = catchAsyncActionError(
  ({ subCompanyId }) =>
    async dispatch => {
      const { data } = await subCompaniesApi.getCompanyProfile(subCompanyId);

      return dispatch({
        type: SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.GET_COMPANY_PROFILE,
        payload: data,
      });
    },
);

// Enhancement-only read for surfaces that only decorate with the company view (the SubCompany
// header's DBA list): a 403 must not trip the global forbidden page-reload or toast. A failure
// resolves to null WITHOUT touching the store, so a transient header failure cannot wipe a profile
// another surface (the Certification tab) already loaded; the caller falls back to the SubCompany's
// own fields.
export const getSubCompanyCompanyProfileQuietAction =
  ({ subCompanyId }) =>
  async dispatch => {
    try {
      const { data } = await subCompaniesApi.getCompanyProfile(subCompanyId, {
        skipForbidden: true,
      });

      return dispatch({
        type: SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.GET_COMPANY_PROFILE,
        payload: data || null,
      });
    } catch {
      return null;
    }
  };

export const updateSubCompanyCompanyProfileSectionAction = catchAsyncActionError(
  ({ subCompanyId, section, body }) =>
    async dispatch => {
      const { data } = await subCompaniesApi.updateCompanyProfileSection({
        id: subCompanyId,
        section,
        body,
      });

      return dispatch({
        type: SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.UPDATE_COMPANY_PROFILE_SECTION,
        payload: { section, data },
      });
    },
);

export const resetSubCompanyCompanyProfileAction = () => ({
  type: SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.RESET_COMPANY_PROFILE,
});
